@if (isVisible && caller) {
  <div class="call-overlay">
    <div class="call-panel">
      <div class="avatar-wrap" [class.ringing]="mode === 'incoming'">
        @if (fileService.getFileURL(caller.profilePicture); as url) {
          <img class="avatar" [src]="url" alt="">
        } @else {
          <div class="avatar avatar-fallback"><i class="fa-solid fa-user"></i></div>
        }
      </div>

      <h2 class="caller-name">{{ caller.firstName }} {{ caller.lastName }}</h2>
      <p class="call-status">{{ mode === 'incoming' ? 'Incoming Voice Call' : mode === 'outgoing' ? 'Calling…' : elapsed }}</p>

      <div class="call-actions">
        @if (mode === 'incoming') {
          <button class="call-btn decline" (click)="onDecline()" [disabled]="isAccepting || isDeclining" title="Decline">
            <i class="fa-solid fa-phone-slash"></i>
          </button>
          <button class="call-btn accept" (click)="onAccept()" [disabled]="isAccepting || isDeclining" title="Accept">
            <i class="fa-solid fa-phone"></i>
          </button>
        } @else if (mode === 'outgoing') {
          <button class="call-btn decline" (click)="onCancel()" title="Cancel">
            <i class="fa-solid fa-phone-slash"></i>
          </button>
        } @else {
          <button class="call-btn decline" (click)="onEnd()" title="End call">
            <i class="fa-solid fa-phone-slash"></i>
          </button>
        }
      </div>
    </div>
  </div>
}
